

import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import MgpFormRadioBox from '../../elements/MgpFormRadioBox/MgpFormRadioBox';
import { accessJsonAttr } from '../../utils/utils';
import { isPropositionInLock } from '../../utils/dataUtils';
import { validEmail,  } from "../../services/CustomerApiService";
import { AxiosError } from 'axios';
import MgpFormCheckbox from '../../elements/MgpFormCheckbox/MgpFormCheckbox';


type InfoPersoStep5FormData = {
  email: string;
  phoneNumber: string;
  showCommercialMgpChoice: boolean;
  commercialEmailAccept: string;
  commercialSmsAccept: string;
  commercialTelephoneAccept: string;
  commercialPartnerAccept: string; 
  isForeignMobile: boolean
}

export default function InfoPersoStep5FormComponent() {

  const {
    state: { proposition, updatedProposition, jwtToken },
    dispatch,
  } = useAppState();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
    .required(ERROR_MESSAGES.requiredMsg)
    .email(ERROR_MESSAGES.invalidMsg)
    .test("is-email-valid", ERROR_MESSAGES.invalidEmailMsg, async (value, values) => {
      if(!value) {
        return false;
      }
      const valid = await onValidEmail(value, values);
      return valid;
    }),
    phoneNumber: Yup.string()
      .when('isForeignMobile', {
          is: false,
          then: Yup.string()
                  .required(ERROR_MESSAGES.requiredMsg)
                  .matches(/^(0[6-7])([ .-]?\d{2}){4}$/, ERROR_MESSAGES.invalidFrenchMobile)
                  .min(14, ERROR_MESSAGES.invalidMsg),
      })
      .when('isForeignMobile', {
          is: true,
          then: Yup.string()
                  .required(ERROR_MESSAGES.requiredMsg)
                  .matches(/^(?:\+|00)[0-9]\d{1,14}$/, ERROR_MESSAGES.invalidForeignMobile)
                  .test("number-is-french", ERROR_MESSAGES.invalidFrenchMobileWithIndicator, async (value, values) => {
                    if(!value) {
                      return false;
                    }
                    const isFrenchNumber = value.startsWith("0033") || value.startsWith("+33");
                    return !isFrenchNumber;
                  }),
                  
      }),
    
    commercialTelephoneAccept: Yup.string().required(ERROR_MESSAGES.requiredMsg),
    commercialEmailAccept: Yup.string().required(ERROR_MESSAGES.requiredMsg),
    commercialSmsAccept: Yup.string().required(ERROR_MESSAGES.requiredMsg),
    // commercialPartnerAccept: Yup.string().required(ERROR_MESSAGES.requiredMsg),
  });
  
  const navigate = useNavigate();
  const [showCommercialMgpChoice, setShowCommercialMgpChoice] = useState<boolean>(true);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<InfoPersoStep5FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      email: updatedProposition?.email ? updatedProposition.email : "",
      showCommercialMgpChoice: true,
      isForeignMobile: updatedProposition?.isForeignMobile ? updatedProposition.isForeignMobile : false,
      phoneNumber: updatedProposition?.phoneNumber && !updatedProposition?.isForeignMobile ? updatedProposition.phoneNumber.replace(/[^\dA-Z]/g, '').replace(/(.{2})/g, '$1 ').trim(): updatedProposition?.phoneNumber && updatedProposition?.isForeignMobile ? updatedProposition?.phoneNumber : "",
      commercialEmailAccept: updatedProposition?.consent?.commercialEmailAccept !== undefined ? updatedProposition.consent.commercialEmailAccept.toString() : undefined,
      commercialSmsAccept: updatedProposition?.consent?.commercialSmsAccept !== undefined ? updatedProposition.consent.commercialSmsAccept.toString() : undefined,
      commercialTelephoneAccept: updatedProposition?.consent?.commercialTelephoneAccept !== undefined ? updatedProposition.consent.commercialTelephoneAccept.toString() : undefined,
      commercialPartnerAccept: updatedProposition?.consent?.commercialPartnerAccept !== undefined ? updatedProposition.consent.commercialPartnerAccept.toString() : undefined,
    },
    resolver: yupResolver(validationSchema),
  });

  const onNextAction = async (data: InfoPersoStep5FormData) => {
    let tempUpdatedPropo = updatedProposition;
    if(tempUpdatedPropo) {
      tempUpdatedPropo.email = data.email;
      tempUpdatedPropo.phoneNumber = data.phoneNumber.replace(/ /g, '');
      tempUpdatedPropo.isForeignMobile = data.isForeignMobile;
      tempUpdatedPropo.consent = {
        showCommercialMgpChoice: true,
        commercialEmailAccept: data.commercialEmailAccept === 'true',
        commercialSmsAccept: data.commercialSmsAccept === 'true',
        commercialTelephoneAccept: data.commercialTelephoneAccept === 'true',
        commercialPartnerAccept: false,   
      }
    
      let nextUrl = APP_URLS.recapPage;
      if (proposition!.configuration.hasIdentityUploadStep) {
        nextUrl = APP_URLS.infoPersoStep6Page;
      } else if(proposition!.configuration.hasSalaryStep){
        nextUrl = APP_URLS.infoPersoStep7Page;
      } else if(proposition?.configuration.canBeAddedBeneficiaries || proposition?.configuration.hasOfferStep){
        nextUrl = APP_URLS.infoPersoRecapPage;
      }
      dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo});
        navigate({
          pathname: nextUrl,
          search: `?id=${proposition!.propositionId}`,
        });
    }
  }

  const onPreviousAction = () => {
    dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoPersoStep4Page});
    navigate({
      pathname: APP_URLS.infoPersoStep4Page,
      search: `?id=${proposition!.propositionId}`,
    });
  }

  const onValidEmail = async (email: string, values: Yup.TestContext<any>) => {
    try {
      const token = jwtToken!.accessToken;
      const res = await validEmail(token, email);
      if (res.data.valid !== undefined && res.data.valid === true) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      return true;
    }
  }

  const isForeignMobileValue = watch("isForeignMobile");

  const handleChangeisForeignMobileCheckbox = (e: any) => {
    setValue("isForeignMobile", e.target.checked);
    clearErrors("phoneNumber");

    if (e.target.checked) {
      setValue("phoneNumber", "+");
    } else {
      setValue("phoneNumber", "");
    }
  }

  const handleChangePhoneNumber = (e: any) => {
    const regexSpace = new RegExp("(.{"+ 2 + "})", "g");
    let target = e.currentTarget, position = target.selectionEnd, length = target.value.length;
    target.value = target.value.replace(/\s/g, '').replace(regexSpace, '$1 ').trim();
    target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
    setValue("phoneNumber", target.value);
  }

  return (          
    <form style={{width: '100%'}}>
      <div className='form-row page-content'>
        <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
          <h2 className='card-title bleu mb-xs'>Mes modalités de contact</h2>
          <p className='text pb-sm' style={{textAlign: 'justify'}}>Vos coordonnées sont nécessaires à la gestion de votre contrat frais de santé. Ces données doivent donc être saisies avec exactitude.
              Pour faciliter nos échanges, veuillez remplacer votre email professionnel par votre email personnel.</p>
          <div className=""> 
            <div className='form-row'>
              <div className="form-group mw-100">
                <MgpFormInput
                    label="Email personnel"
                    id="email"
                    labelFontWeight='medium'
                    register={register} 
                    errors={errors}
                    required={true}
                />
              </div>
            </div>

            <div className='form-row'>
              <div className="form-group mw-100">
                <p className='text fw-medium'>Numéro de téléphone portable <span className='fushia'>(*)</span></p>
                <div className='form-group form-check mw-100'>
                  <MgpFormCheckbox 
                    id='isForeignMobile' 
                    label="Numéro hors France métropolitaine" 
                    register={register} 
                    errors={errors} 
                    required={false}
                    inputSize='small'
                    onChange={(e: any) => handleChangeisForeignMobileCheckbox(e)}
                  />
                </div>
                <div className='mt-sm'>
                  {
                    watch("isForeignMobile") ?
                    <MgpFormInput
                      label=""
                      id="phoneNumber"
                      placeholder="Ex: 00xxxxxxxx ou +xxxxxxxxxx"
                      labelFontWeight='medium'
                      maxLength={15}
                      register={register} 
                      errors={errors}
                      required={true}
                      value={watch("phoneNumber")}
                    />
                    :
                    <MgpFormInput
                      label=""
                      id="phoneNumber"
                      placeholder="Ex: 06 05 04 03 02"
                      labelFontWeight='medium'
                      maxLength={14}
                      autospace={2}
                      register={register} 
                      errors={errors}
                      required={true}
                      value={watch("phoneNumber")}
                      onChange={(e) => handleChangePhoneNumber(e)}
                    />
                  }
                  

                </div>
              </div>
              
            </div>
            
            {
              isForeignMobileValue &&
                <div className="form-group mw-100 mt-sm">
                  <p className='bg-menthe blanc p-xs flex va-center jc-start' style={{gap: "10px", flexWrap: "unset"}}>
                    <i className='icon-info blanc '></i>
                    <span >Veuillez saisir votre numéro de mobile complet avec l'indicatif.</span>
                  </p>
                </div>
              
            }               
          </div>
        </div>

        <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
        
          <p className='text ta-justify'>Vos besoins évoluent : bénéficiez de conseils personnalisés et d’informations sur les offres et services proposés par la MGP.</p>
          <p className='text ta-justify mb-sm'>J'accepte de recevoir des informations sur les solutions proposées par la MGP&nbsp;:</p>
        
          {showCommercialMgpChoice&&
          <>
          <div className="form-row">
            <p className='form-check-label fw-medium text custom'>Par téléphone<span className='fushia'> (*)</span></p>
            <div className="form-group form-group-radio form-group-radio-custom">
              <MgpFormRadioBox id ='commercialTelephoneAccept' value='true' register={register} label="Oui" errors={errors} />
              <MgpFormRadioBox id ='commercialTelephoneAccept' value='false' register={register} label="Non" errors={errors} />
            </div>
          </div>
          <div className="form-row">
            <p className='form-check-label fw-medium text custom'></p>
            {errors && accessJsonAttr(errors, 'commercialTelephoneAccept') && <p className="error">Ce champ est obligatoire</p>}
          </div>
          <div className="form-row">
            <p className='form-check-label fw-medium text custom'>Par mail<span className='fushia'> (*)</span></p>
            <div className="form-group form-group-radio form-group-radio-custom">
              <MgpFormRadioBox id ='commercialEmailAccept' value='true' register={register} label="Oui" errors={errors} />
              <MgpFormRadioBox id ='commercialEmailAccept' value='false' register={register} label="Non" errors={errors} />
            </div>
          </div>
          <div className="form-row">
            <p className='form-check-label fw-medium text custom'></p>
            {errors && accessJsonAttr(errors, 'commercialEmailAccept') && <p className="error">Ce champ est obligatoire</p>}
          </div>
          
          <div className="form-row">
            <p className='form-check-label fw-medium text custom'>Par SMS<span className='fushia'> (*)</span></p>
            <div className="form-group form-group-radio form-group-radio-custom">
              <MgpFormRadioBox id ='commercialSmsAccept' value='true' register={register} label="Oui" errors={errors} />
              <MgpFormRadioBox id ='commercialSmsAccept' value='false' register={register} label="Non" errors={errors} />
            </div>
          </div>
          <div className="form-row mb-md">
            <p className='form-check-label fw-medium text custom'></p>
            {errors && accessJsonAttr(errors, 'commercialSmsAccept') && <p className="error">Ce champ est obligatoire</p>}
          </div>
          </>}

          {/* <div className="form-row mb-md">
            <p className='fw-medium text'>Découvrez également les offres des partenaires de la MGP</p>
          </div> */}
          
          {/* <div className="form-row mb-md">
            <div className='text'>
              J'accepte de recevoir par téléphone / email / SMS des offres commerciales des partenaires de la MGP :
              &nbsp;<MgpTooltip text={<span className='text'>Liste de nos partenaires :<br/>GMF<br/>Banque Française Mutualiste</span>} children={<span className="fw-medium text bleu" >consultez la liste de nos partenaires</span>} position='top'/>
              &nbsp;<span className='fushia'> (*)</span>
            </div>
          </div> */}
          
          {/* <div className="form-row">
            <div className="form-group form-group-radio form-group-radio-custom no-full-width">
              <MgpFormRadioBox id ='commercialPartnerAccept' value='true' register={register} label="Oui" errors={errors}/>
              <MgpFormRadioBox id ='commercialPartnerAccept' value='false' register={register} label="Non" errors={errors}/>
            </div>
          </div>
          <div className="form-row">
            {errors && accessJsonAttr(errors, 'commercialPartnerAccept') && <p className="error">Ce champ est obligatoire</p>}
          </div> */}
          
          <div className="mt-xl">
            <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
          </div>
        
        </div>
      </div>
      
        
        {proposition && isPropositionInLock(proposition) ? (<StickButtonsBloc disabledPreviousButton={true} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>) : (<StickButtonsBloc showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>)}
    </form>
  )
}
